import React, { Component, Fragment } from "react";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import ActiveCampaignForm  from './../modals/activeCompaign'

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => { 
    return ({
        root: {
            padding: theme.spacing(2),
            width: 600,
            height: 350,
            "@media only screen and (max-width:767px)": {
                maxWidth: 350,
                height: "auto",
                width: "100%",
                minWidth: 250,
                minHeight: 400,
            }
        },
    })
})(MuiDialogContent);

class WatchADemo extends Component {

    constructor() {
        super()
        this.state = {
            isShowEmailCaptureModal: false
        }
        this.openEmailCaptureModal = this.openEmailCaptureModal.bind(this)
    }
    
    
    openEmailCaptureModal() {
        this.setState({ 
            isShowEmailCaptureModal: true 
        })
    }

    render() {

        const {isShowEmailCaptureModal} = this.state;

        return (
            <Fragment>
                <Dialog onClose={() => this.setState({ isShowEmailCaptureModal: false })} aria-labelledby="customized-dialog-title" open={isShowEmailCaptureModal}>
                    <DialogTitle id="customized-dialog-title" onClose={() => this.setState({ isShowEmailCaptureModal: false })}>
                        Watch a demo
                </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom component="span">
                                <ActiveCampaignForm embedClass={"_form_27"} embedId="27"></ActiveCampaignForm>
                        </Typography>
                    </DialogContent>
                </Dialog>
                <a style={{ 'background': '#fff', 'border': '2px solid #e95e00', 'color': '#e95e00' }}
                                            className={`btn circle btn-light border btn-md popup-youtube ${this.props.mrgnClass} light video-inline`}
                                            onClick={this.openEmailCaptureModal}>Watch a demo</a>
            </Fragment>
        );

    }
            

}

export default WatchADemo;



// WEBPACK FOOTER //
// ./src/modals/watchADemo.js